<!--运营指标-->
<template>
  <div class="taskIndicators">
    <span class="firstTitle"><i></i>基本信息</span>
    <div class="userIndicators flex justify-between align-center">
      <div class="indicator" v-for="(item,index) in opList1" :key="index">
        <img class="bg" :src="item.img"/>
        <div>
          <p class="text text-xss">{{item.text}}</p>
          <p class="counts text-xl">{{item.counts}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import icon0 from "@/assets/images/battery/icon0.png";
  import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      options: {},
      bigtitle:{
        CHN:'充电过程电池信息',
        ENG:'Evaluation index'
      },
      opList1:[{
              text:'充电机序号',counts:'',img:icon0
            },{text:'充电倍率',counts:'',img:icon0},
            {text:'额定功率',counts:'',img:icon0},
            {text:'最大允许输出功率',counts:'',img:icon0},
            {text:'最大允许充电功率',counts:'',img:icon0},
            {text:'充电控制器硬件版本号',counts:'',img:icon0},
            {text:'充电控制器软件版本',counts:'',img:icon0},
          ]
    }
  },
  components: {
  },
  props: {
    // userList: {
    //   type: Object,
    //   default: () => ({})
    // },
  },
  watch: {
    
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.getBatteryChargerInfo(data);
    },
    //
    getBatteryChargerInfo(data={}){
      let _this = this;
      let params = {
					"enCode":"TiDB-dianchixiang-chongdianjixinxi",
          "@equipNo":data.equipNo
				}
        dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res = res[0];
          console.log("充电机信息",res)
          _this.opList1 = [{
              text:'充电机序号',counts:res.chargerNumber,img:icon0
            },{text:'充电倍率(C)',counts:res.rateOfCharge,img:icon0},
            {text:'额定功率(kW)',counts:res.ratedPower,img:icon0},
            {text:'最大允许输出功率(kW)',counts:res.maxallowOutputPower,img:icon0},
            {text:'最大允许充电功率(kW)',counts:res.maxallowChargingRate,img:icon0},
            {text:'充电控制器硬件版本号',counts:res.chargingControllerHdv,img:icon0},
            {text:'充电控制器软件版本',counts:res.chargingControllerSfv,img:icon0},
          ]

          console.log(_this.opList1)
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>
<style lang="scss" scoped>


.taskIndicators{
  width:100%;
  margin-bottom:15px;
}

.userIndicators,.opIndicators{
  // width:511px;
  // display: grid;
  // grid-template-columns: 25% 25% 25% 25%;
  // grid-template-rows: 50% 50%;
  height:158px;
  background: linear-gradient(180deg, rgba(47, 164, 159, 0.11) 0%, rgba(1, 177, 169, 0.06) 79%, rgba(53, 149, 147, 0.11) 100%);
  padding-left:35px;
  padding-right:35px;

}
.userIndicators{
  .bg{
    width:70px;
    height:70px;
    margin-left:10px;
    margin-right:20px;
  }
  .indicator{
    display: flex;
    // margin-top:20px;
    // margin-bottom:30px;
    .counts{
      color: #1BBEEE;
    }
    .text{
      color: #FFFFFF;
    }
  }
}
.opIndicators{
  .bg{
    width:89px;
    height:53px;
    // margin-right:20px;
  }
  .indicator{
    display: flex;
    // margin-top:20px;
    // margin-bottom:30px;
    .counts{
    }
    .text{
    
    }
  }
}
.arrow{
  width:12px;
  height:18px;
}
.firstTitle {
  width: 590px;
  height: 35px;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 34px;
  display: flex;
  background: url("~@/assets/images/index/title.png") no-repeat;
  background-size: cover;
  padding-left: 30px;
}
</style>